import axios from 'axios';

export const genera = function (url, top, skip, sortProperty, sortOrder, filters) {
  let urlFinale = url;

  if (urlFinale.indexOf('?') == -1) {
    urlFinale += '?';
  } else {
    urlFinale += '&';
  }

  if (top != undefined && skip != undefined) {
    urlFinale += `$top=${top}&$skip=${skip}`;
  }

  if (sortProperty != undefined) {
    urlFinale += `&$orderby=${sortProperty}`;
    if (sortOrder) {
      urlFinale += ' asc';
    } else {
      urlFinale += ' desc';
    }
  }

  if (filters != undefined && filters.length > 0) {
    urlFinale += `${urlFinale.substring(urlFinale.length - 1) == '?' ? '' : '&'}$filter=${filters.join(' and ')}`;
  }

  return urlFinale;
};

const OData = {
  generaUrl(url, top, skip, sortProperty, sortOrder, filters) {
    return genera(url, top, skip, sortProperty, sortOrder, filters);
  },

  cerca(url, top, skip, sortProperty, sortOrder, filters) {
    const urlFinale = genera(url, top, skip, sortProperty, sortOrder, filters);

    const cors = urlFinale.indexOf('http://') == 0 || urlFinale.indexOf('https://') == 0;

    return axios({
      url: urlFinale,
      method: 'get',
      type: 'json',
      headers: {
        'Content-Type': 'application/json',
      },
      contentType: 'application/json',
      withCredentials: cors,
    })
      .then((response) => response.data);
  },
};

export default OData;

export const ODataV2 = {
  getUrl: (u) => u,
  load: OData.cerca,
};
